(()=>{
    if (window.innerWifth > 749) return
    document.querySelectorAll('.footer .accordion').forEach(tab => {
        const [heading] = tab.children
        heading.addEventListener("click", ()=> {
            const isOpen = tab.getAttribute("aria-expanded") === "true"
            tab.setAttribute("aria-expanded", !isOpen)
        })
    })
})()